import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DemoLogin = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const autoLogin = async () => {
      try {
        const res = await fetch('/api/v1/auth/demo');
        const data = await res.json();
        if (data.success) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
          const moduleRoutes = { comms: '/dashboard', helpdesk: '/helpdesk', fsm: '/fsm/dashboard' };
          navigate(moduleRoutes[data.user.default_module] || '/dashboard');
        } else {
          setError(data.message || 'Demo not available');
        }
      } catch (e) {
        setError('Failed to connect');
      }
    };
    autoLogin();
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0a1929', color: '#fff', fontFamily: 'sans-serif' }}>
      {error ? (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <div style={{ fontSize: '18px', color: '#ff6b6b' }}>{error}</div>
          <button onClick={() => window.location.href = '/login'} style={{ marginTop: '20px', padding: '10px 24px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', cursor: 'pointer', fontSize: '16px' }}>
            Go to Login
          </button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px', animation: 'spin 1s linear infinite' }}>⚙️</div>
          <div style={{ fontSize: '20px', fontWeight: '600' }}>Setting up your demo...</div>
          <div style={{ fontSize: '14px', color: '#94a3b8', marginTop: '8px' }}>جاري تجهيز النسخة التجريبية</div>
          <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </div>
      )}
    </div>
  );
};

export default DemoLogin;
